import * as Utils from './utils'

import OFFICE_SORT_ORDER from './order'
import officeTpl from '../templates/office.html'
import raceTpl from '../templates/race.html'

const config = window.EMBED_CONFIG

export default function buildNestedRaces (races) {
  return new Promise((resolve, reject) => {
    const payload = races.map((obj, idx) => {
      const races = obj.values.reduce((prev, race) => {
        race.votes = Utils.getRaceVoteTotal(race.candidates)
        return prev + raceTpl({ race, Utils, is_embed: config.is_embed })
      }, '')

      const title = OFFICE_SORT_ORDER[obj.key]
      let officePayload = officeTpl({office_id: obj.key, title, races})
      if (idx === 2) officePayload += '<aside class="ad-slot"><div id="ad-banner-leader"></div></aside>'

      return officePayload
    }).join('')

    resolve(payload)
  })
}



/** WEBPACK FOOTER **
 ** ./utils/buildNestedRaces.js
 **/